<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Firstmile Rider Mapping</strong>
            <div class="card-header-actions" >                
              <button class="btn btn-sm btn-primary mr-4 btn-pill" @click="openaddvendermodel =! openaddvendermodel"  type="button"><i class="fa fa-plus"></i>Add Vendor Mapping</button> 
              <router-link to="/vendorcodes"> 
              <button class="btn btn-sm btn-primary mr-4 btn-pill"   type="button"> Available Vendor Code</button> </router-link>
              <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button> 
            </div>
          </div>

         
          <div>
            <b-collapse id="addzone"  v-model="openaddvendermodel">
              <b-card>
                <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                  <b-row> 
                    <b-col md="4" >
                      <b-form-group label="Select Rider"  :label-cols="4" >
                        <b-form-select v-model="customer.deliveryagentmasterid" name="deliveryagentname"  v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentname') }">
                            <option :value="selected"  >--Select--</option>
                            <option  :value="customer.deliveryagentmasterid" v-for="customer in data1"  :disabled="customer.capacityforallocation== 0">{{ customer.deliveryagentmasterid }}-{{ customer.deliveryagentfirstname | capitalize }}- {{ customer.deliveryagentlastname | capitalize }} - {{ customer.deliveryagentmobilenumber }}</option>
                        </b-form-select> 
                        <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  
                  <b-row>
                    <b-col md="6" >
                      <div class="form-group row">
                        <label class="col-md-4 col-form-label" for="hf-email">Vendor Codes</label>
                        <vue-tags-input
                          v-model="customer.vendorcodelisting" :tags="tags1"
                          @tags-changed="newTags => tags1 = newTags" ref="taginput"
                          v-bind:separators="[',', ';']" />
                          <span v-show="errors.has('form-1.vendorcodelisting')" class="help text-danger">{{ errors.first('form-1.vendorcodelisting') }}</span>
                      </div>
                    </b-col>
                  </b-row> 
                  
                  <b-row>
                    <b-col sm="2">
                      <b-button variant="primary" size="md" type="submit">Save</b-button>
                    </b-col>
                  </b-row>
                      
                </b-form>
              </b-card>
            </b-collapse>
           
          </div>
          
          <div id="overlay" >
             <div class="loader"></div>
          </div>

          <b-row>
             <b-col md="5" class="my-1">
                <b-form-group label-cols-sm="2" label="Filter: " class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          
          <b-col sm="12" class="text-right">
            <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button> 
              <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
          </b-col>  

          <b-col sm="12" >
            <b-table show-empty responsive  :items="items" :busy="isBusy"  :fields="fields1"  :current-page="currentPage"   :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

              <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
              </div>  

              <template slot="clientvendorlist" slot-scope="row">
                <span
                  v-for="(vendor, index) in row.item.clientvendorlist.split(',')"
                  :key="index"
                >
                  <span v-if="vendor.includes('(')">
                    {{ vendor.substring(0, vendor.indexOf('(')) }}
                    <strong>
                      {{ vendor.substring(vendor.indexOf('(')) }}
                    </strong>
                  </span>

                  <span v-else>
                    {{ vendor }}
                  </span>

                  <span v-if="index < row.item.clientvendorlist.split(',').length - 1">
                    ,
                  </span>
                </span>
              </template>

              <template slot="actions" slot-scope="row">
                <div style="    display: flex;
                justify-content: start;
                align-items: center;">
                    <b-button size="sm" @click="editinfoModal(row.item)" class="mr-1" style="background: #b0c4de !important;color: #000 !important;">
                        Edit
                    </b-button>&nbsp;&nbsp;

                    <b-button size="sm" @click="addpalletinfoModal(row.item)" class="mr-1" style="background: #b0c4de !important;color: #000 !important;" v-if="row.item.pallet_title == null && userCountry=='KSA'" >
                          Add Pallet
                    </b-button>
    
                    <b-button size="sm" @click="editpalletinfoModal(row.item)" class="mr-1" style="background: #b0c4de !important;color: #000 !important;" v-if="row.item.pallet_title != null && userCountry=='KSA'">
                          Edit Pallet
                    </b-button>
                      <input
                        @change="setpalletStickerHTMl($event, row.item)"
                        type="radio"
                        name="radAnswer"
                        v-model="row.item.selected"
                        class="shipmentscheckbox"
                        id="stiker"
                        :checked="checkedpalletData" v-if="row.item.pallet_title != null && userCountry=='KSA'"
                      />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                      <b-button
                        id="printbutton"
                        variant="primary"
                        size="sm"
                        value="print a div!"
                        @click="
                          barcodepalletdata('printablePalletArea', row.item)
                        "
                        style="background: #b0c4de !important;color: #000 !important;" v-if="row.item.pallet_title != null && userCountry=='KSA'"
                        >Print Pallet </b-button
                      >&nbsp;&nbsp;
                      </div>
                  </template>

                  
            </b-table>
            <div id="printablePalletArea">
              <div class="page-break" v-for="pallet in palletArr">
                <div style="font-size: 25px;">
                  <b>{{ pallet.pallet_title }}</b>
                </div>
                <!-- <br> -->
                <br />
                <qr-code :text="pallet.pallet_id"></qr-code>
              </div>
            </div>
          </b-col>

          <b-modal title="Update Pin Codes " v-model="editAgentMaster" @ok="editAgentMaster = false" hide-footer>
            <template slot="modal-header" slot-scope="{ close }">
            <h5>Update Vendor Codes</h5>
            </template>
            <template slot="default" slot-scope="{ hide }">
              <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">
                
                  <b-form-group label="Select Rider"  :label-cols="4" >

                    <b-form-select v-model="updatecustomer.deliveryagentmasterid" id="deliveryagent_from" name="deliveryagentname" :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentname') } ">
                          <option value=" ">None</option>
                          <option   :value="customer.deliveryagentmasterid" v-for="customer in data1"  :disabled="customer.capacityforallocation== 0">{{ customer.deliveryagentmasterid }}-{{ customer.deliveryagentfirstname | capitalize }} -{{ customer.deliveryagentlastname | capitalize }}  </option>
                      </b-form-select> 

                      <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
                    </b-form-group>

                            <b-form-group label=" Vendor Codes"  :label-cols="4" >
                  
                  <vue-tags-input
                        v-model="updatecustomer.vendorcodelisting" 
                      :tags="tags2"

    
                      @tags-changed="newTags => tags2 = newTags  "
                      ref="taginput"
                      v-bind:separators="[',', ';']"

                    
                    />
                    
                      <span v-show="errors.has('form-1.vendorcodelisting')" class="help text-danger">{{ errors.first('form-1.vendorcodelisting') }}</span>
                    </b-form-group> 
                  
                  
            
                      

                  
                  <div slot="footer" class="text-right">
                    <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button>
                    <b-button  size="sm" variant="danger" @click="editcancel(); ">cancel</b-button>
                  </div>
                </b-form>
            </template>
            <template slot="modal-footer" slot-scope="{ hide }">
              <!-- Emulate built in modal footer ok and cancel button actions -->
              <b-button size="sm" style="display:none">
                Cancel
              </b-button>
              <!-- Button with custom close trigger value -->
            </template>
          </b-modal> 

          <b-modal title="Add Pallet Info" v-model="addpalletinfo" @ok="addpalletinfo=false" hide-footer size="md">
            <div>
              <div id="modeloverlay" style="display: none;">
                <div class="modelloader"></div>
             </div>
              <b-row>
                <b-col sm="4">
                  <strong>Add Pallet Name </strong>
                </b-col>
                <b-col>
                  <b-form-input v-model="palletname" placeholder="Enter Pallet Name"></b-form-input>
                </b-col>
              </b-row>
              <br>
              <div class="text-right">
                <b-button variant="primary" @click="addpalletname()">Save</b-button>
              </div>
            </div>
          </b-modal>

          <b-modal title="Edit Pallet Info" v-model="editpalletinfo" @ok="editpalletinfo=false" hide-footer size="md">
            <div>
              <div id="modeloverlay" style="display: none;">
                <div class="modelloader"></div>
             </div>
              <b-row>
                <b-col sm="4">
                  <strong>Edit Pallet Name </strong>
                </b-col>
                <b-col>
                  <b-form-input v-model="selected_pallettitle" placeholder="Enter Pallet Name"></b-form-input>
                </b-col>
              </b-row>
              <br>
              <div class="text-right">
                <b-button variant="primary" @click="editpalletname()">Save</b-button>
              </div>
            </div>
          </b-modal>

          <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0">
            </b-pagination>
          </b-col>    
        </b-card>
       
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'zonemaster', 
  data: function() {
    return {
      name: 'zonemaster',
      isBusy: false,
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'Zone Master',
        active: true
      }],
      add: true,      
      items:[],   
      fields1:[],
      tags2:[], 
      bordered: true,
      totalRows: 0,
      showSelectAll : true,
      currentPage: 1,
      perPage:  10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      options:[],
      fields: { text: 'name', value: 'id' },
      zoneno:'',
      value2:[],
      // tags:[],
      // tags1:[],
      // tags2:[],
      pincodelist:[],
      pincodeoptions:[],
      sortDesc: false,
      allowCustomValue : true,
      sortDirection: 'desc',
      filter: null,
      customer:{},
      data1:[],
      selected:'',
      editAgentMaster:false,
      addpalletinfo :false,
      palletname :'',
      editpalletinfo : false,
      editpallet_name : '',
      addpalletvalueinfo :[],
      editpalletvalueinfo :[],
      userCountry :'',
      selected_pallettitle :'',
      checkedpalletData: false,
      palletArr: [],
      selected_pallet_id: "",
      openaddvendermodel: false,
      tags1:[],
      updatecustomer:{},
    }
  },
  created: function() { 
  
   // this.pincodes(); 
  
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    console.log("00000000000000000000000",userInfo)
    this.userCountry = userInfo.country;
    this.displayagent();
    this.displaydata();
  },
  computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  methods: {
     
    validateForm(scope) {
       this.$validator.validateAll(scope).then(result => {
        if (result) {          
          this.addvendorInfo();
        }
      });
    },
    
    zoneadd: function() {
      this.errors.clear("form-1");
   
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addzone = document.getElementById("addzone");
      addzone.style.display = "block";
    
    },
    
    addvendorInfo: function() {

      if (this.tags1.length==0) {
        this.$fire({
                  text:'Please Enter Vendor Codes',
                  type: "warning",
                  timer: 30000
                }); 
                return false;
      }
      var pincodelistingarr=[];
       for(var i = 0; i < this.tags1.length; i++) {
          pincodelistingarr.push(this.tags1[i].text);  
       }
      
     const pincodesave = {
          deliveryagentmasterid:this.customer.deliveryagentmasterid,
          clientvendorcode:pincodelistingarr,
        }
              console.log(pincodesave);
    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/assignvendortorider`,pincodesave)
        .then((result) => {
         if (result.body.returnmsg === "Successful") {
                 // Utils.notify("Added successfully", "success");
                 this.$fire({
                  text:"Added successfully",
                  type: "success",
                  timer: 30000
                }); 
                 
                  this.clear();
                 
                  this.displaydata();
                  this.openaddvendermodel=false;
                  var addzone = document.getElementById("addzone");
                  addzone.style.display = "none";
                  this.$router.push('/firstmileridermapping');
                } else {
            // Utils.notify(result.body.returnvalue);
            this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
      
    },

    downloadCSV: function() {
      document.getElementById("overlay").style.display = "block";

      var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
      // alert("working");
      const info = {
          sysusermasterid:`${userInfo.sysusermasterid}`,  
            
            }
            console.log(info);
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getvendorandridermappinglistcsv_advanced`,info)
              .then(result => {
                document.getElementById("overlay").style.display = "none";
              console.log(result.url);
              if(result.body=="success")
              {
              // alert("Please Check Ur Mail For Downlod Link")
              this.$fire({
                        text:"Please Check Ur Mail For Downlod Link",
                        type: "success",
                        timer: 30000
                      }); 
            }
            else
            {
              // alert("Can not Download");
              this.$fire({
                        text:"Can not Download",
                        type: "error",
                        timer: 30000
                      }); 
            }
            // window.location.href =result.url;
              });
        
    },

    validateForm5(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
           this.updatevendorcodes();
        }
      });
    },

    updatevendorcodes: function() { 
  
      if (this.tags2.length==0) {
        this.$fire({
          text:'Please Add Vendor Codes',
          type: "warning",
          timer: 30000
        }); 
        return false
      }
    var pincodelistarr=[];
       for(var i = 0; i < this.tags2.length; i++) {
    if(this.tags2[i].text== null || this.tags2[i].text=="undefined" || this.tags2[i].text=="")
        {
           pincodelistarr.push(this.tags2[i]);

        }
          else
          {
             pincodelistarr.push(this.tags2[i].text);
          }
        // console.log("val"+this.tags2[i]);
            
       }
    
      var Obj = {
          deliveryagentmasterid : this.updatecustomer.deliveryagentmasterid,
          clientvendorcode : pincodelistarr,
         
            
      
      };  
       // console.log(Obj);
    
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/updatevendortorider`,
            Obj
          ).then(result => {
             if (result.body.returnmsg === "Successful") {
            // alert("updated successfully");
            this.$fire({
                  text:"Updated Successfully",
                  type: "success",
                  timer: 30000
                }); 

            this.editAgentMaster = false;
            this.customer = {};

            this.displaydata();
             this.tags=[];
              this.$router.push('/firstmileridermapping').catch(()=>{});
            }
            else {
            // Utils.notify(result.body.returnvalue);
             this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });

                
      
    }, 

    displaydata: function () {
      //alert("zone & pin codes");
    this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      

      if (this.userCountry=='KSA') {
        // console.log(":;;;;;;;;;;;;;;;;")
        this.fields1= [
            { key: 'ridername', label: 'Rider Name', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
            { key: 'clientvendorlist', label: 'Vendor Code', sortable: true,tdClass: 'vendorCodeColumn'},
            //{ key: 'vendorname', label: 'Vendor Name', sortable: true,tdClass: 'nameOfTheClass'},
            { key: 'pallet_title', label: 'Pallet Title', sortable: true,tdClass: 'nameOfTheClass'},
            { key: 'actions', label: 'Actions' ,tdClass: 'nameOfTheClass'},
        ]
      }

      if (this.userCountry=='ME') {
        console.log(":;;;;;;;;;;;;;;;;")
        this.fields1= [
            { key: 'ridername', label: 'Rider Name', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
            { key: 'clientvendorcode', label: 'Vendor Code', sortable: true,tdClass: 'nameOfTheClass'},
            { key: 'vendorname', label: 'Vendor Name', sortable: true,tdClass: 'nameOfTheClass'},
            { key: 'actions', label: 'Actions' ,tdClass: 'nameOfTheClass'},
        ]
      }
      
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getvendorandridermappinglist`)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             this.items  = result.body.returnvalue;
             // console.log(this.items);
             this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
          } else {
            this.items=[];
            this.totalRows =0;
               this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
     
    editinfoModal: function(value) {
      console.log("value",value)
    
     this.tags2=value.clientvendorcode.split( ",");
     
      // console.log(this.tags2);
  
      
      this.updatecustomer.deliveryagentmasterid = value.deliveryagentmasterid;
      //this.customer.vendorcodelisting=this.tags2.text;
      
     //  console.log(this.customer.zonename);

     // this.tags=value.pincodes.split( ",");
     
     //  console.log(this.tags);
  
     
            
      this.editAgentMaster = true;
      
      
    },

    editcancel: function() {
        this.tags=[];
      this.customer = {};
      this.editAgentMaster = !this.editAgentMaster;
      
    },

    refresh:function() {
     
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addzone = document.getElementById("addzone");
      addzone.style.display = "none";
      this.clear();
    },
   
    
    displayagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
     console.log("hello"+userInfo.sysemailid);
    
     
      let customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        usertype:'4',

      }
 this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
        .then((result) => {
          this.data1 = result.body
          //this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    
   
    
 
      
    },
    
    clear: function() {
      this.customer.deliveryagentmasterid = '';
      this.customer.vendorcodelisting='';
       this.tags2=[];
       this.tags1=[];
      this.errors.clear('form-1')    
    },

    addpalletinfoModal: function(value){
      // alert("ok")
      this.addpalletvalueinfo = value;
      // console.log("9999999999999999",this.addpalletvalueinfo);
      this.palletname = '';
      this.addpalletinfo = true;
      this.palletArr = [];
      this.checkedpalletData = false;
      this.selected_pallet_id = "";
    },

    addpalletname : function(){
      document.getElementById('modeloverlay').style.display="block";
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata);

      if (this.palletname=='') {
        this.$fire({
          text:'Please Add Pallet Name',
          type: "warning",
          timer: 30000
        }); 
        document.getElementById('modeloverlay').style.display="none";
        return false
      }

      const addpallet = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
        created_by :`${userInfo.sysemailid}`,
        pallet_title : this.palletname,
        deliveryagentmasterid : this.addpalletvalueinfo.deliveryagentmasterid,
      }
      console.log("addpallet",addpallet);

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/createPalletForVendor`,addpallet).then((result) => {
        document.getElementById('modeloverlay').style.display="none";
        console.log("%%%%%%%%%%%%%%%%%%%%%%%%%",result)
        if (result.body.returnmsg === "Successful") {
            this.$fire({
              text:"Added successfully",
              type: "success",
              timer: 30000
            }); 
            this.palletname = '';
            this.addpalletvalueinfo = [];
            this.addpalletinfo = false;
            this.displaydata();
          } 
          else {
            this.$fire({
              text:result.body.returnvalue,
              type: "error",
              timer: 30000
            }); 
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },

    editpalletinfoModal: function(value){
      this.editpalletvalueinfo = value;
      console.log("this.editpalletvalueinfo",this.editpalletvalueinfo.pallet_title)
      this.selected_pallettitle = this.editpalletvalueinfo.pallet_title;
      this.palletname = '';
      this.editpalletinfo = true;
      this.palletArr = [];
      this.checkedpalletData = false;
      this.selected_pallet_id = "";
    },
    
    editpalletname: function(){
      document.getElementById('modeloverlay').style.display="block";
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
      if (this.selected_pallettitle=='') {
        this.$fire({
          text:'Please Add Pallet Name',
          type: "warning",
          timer: 30000
        }); 
        document.getElementById('modeloverlay').style.display="none";
        return false
      }

      const editpallet = {
        pallet_id :this.editpalletvalueinfo.pallet_id,
        pallet_title : this.selected_pallettitle,
      }
      console.log("editpallet",editpallet);

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/editPalletName`,editpallet).then((result) => {
        document.getElementById('modeloverlay').style.display="none";
        console.log("%%%%%%%%%%%%%%%%%%%%%%%%%",result)
        if (result.body.returnmsg === "Successful") {
            this.$fire({
              text:"Added successfully",
              type: "success",
              timer: 30000
            }); 
            this.editpalletvalueinfo = [];
            this.editpalletinfo = false;
            this.displaydata();
          } 
          else {
            this.$fire({
              text:result.body.returnvalue,
              type: "error",
              timer: 30000
            }); 
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },

    barcodepalletdata(printablePalletArea, value) {
      if (
        this.checkedpalletData == true &&
        this.selected_pallet_id == value.pallet_id
      ) {
        var printContents = document.getElementById("printablePalletArea")
          .innerHTML;
        // alert(printContents)
        var disp_setting = "toolbar=yes,location=no,";
        disp_setting += "directories=yes,menubar=yes,";
        disp_setting +=
          "scrollbars=yes,width=650, height=600, left=100, top=25";
        var content_vlue = printContents;
        var docprint = window.open("", "", disp_setting);
        docprint.document.open();
        docprint.document.write(
          '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
        );
        docprint.document.write(
          '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
        );
        docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
        );
        docprint.document.write("<head>");
        docprint.document.write('<style type="text/css">body{ margin:0px;');
        docprint.document.write("font-family:verdana,Arial;color:#000;");
        docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:20px;}"
        );
        docprint.document.write("a{color:#000;text-decoration:none;} ");
        docprint.document.write(
          ".stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} "
        );
        docprint.document.write(
          ".printarea{ font-size: 30px;text-align: center;}"
        );

        docprint.document.write(".addpad{ padding: 10px; }");
        docprint.document.write(
          "@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}"
        );
        docprint.document.write(
          "@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }"
        );
        docprint.document.write(".stickertable td{ padding-bottom:10px;  }");
        docprint.document.write("@page { size: 101.6mm 152.4mm;}</style>");
        docprint.document.write('</head><body onLoad="self.print()"><center>');
        docprint.document.write(content_vlue);
        docprint.document.write("</center></body></html>");
        docprint.document.close();
      } else {
        this.$fire({
          text: "Please Select Check Box",
          type: "warning",
          timer: 30000,
        });
      }
    },

    setpalletStickerHTMl(e, value) {
      // alert(value)
      this.palletArr = [];
      this.checkedpalletData = true;
      this.selected_pallet_id = value.pallet_id;
      // console.log("Valueeeeeeeeeeeeeeee", this.selected_zone_id);
      const obj = {
        pallet_id: `${value.pallet_id}`,
        pallet_title: value.pallet_title,
      };
      this.palletArr.push(obj);
      console.log("TitlwwwwwwpalletArr", this.palletArr);
    },

  }
 
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .nameOfTheClass {
   max-width: 450px;
}
.ti-new-tag-input-wrapper[data-v-61d92e31] {
    display: flex;
    flex: 1 0 auto;
    padding: 34px 70px;
    margin: 2px;
    font-size: .85em;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

.vendorCodeColumn {
  min-width: 600px !important;
  width: 600px !important;
  max-width: 800px !important;
  white-space: normal !important;
  word-break: break-word;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
